<template>
  <StyleQuizResult
    v-if="styleQuizStatus === StyleQuizStatus.DONE"
    :projectInfo="props.projectInfo"
    @onRestart="styleQuizStatus = StyleQuizStatus.EMPTY"
  />
  <StyleQuizEmpty
    v-if="styleQuizStatus === StyleQuizStatus.EMPTY"
    :projectInfo="props.projectInfo"
    @onStartDefinedStylesQuiz="
      styleQuizStatus = StyleQuizStatus.DEFINED_STYLES_QUIZ
    "
    @onStartQuiz="styleQuizStatus = StyleQuizStatus.QUIZ_STYLE"
  />
  <SelectDefinedStyleQuiz
    v-if="styleQuizStatus === StyleQuizStatus.DEFINED_STYLES_QUIZ"
    :projectId="props.projectInfo?.id"
    @onBack="styleQuizStatus = getInitialStyleQuizStatus()"
    @onDone="styleQuizStatus = StyleQuizStatus.DONE"
  />
  <StyleQuizStyle
    v-if="styleQuizStatus === StyleQuizStatus.QUIZ_STYLE"
    @onBack="styleQuizStatus = getInitialStyleQuizStatus()"
    @onDone="styleQuizStatus = StyleQuizStatus.QUIZ_ORNAMENT"
  />
  <StyleQuizOrnament
    v-if="styleQuizStatus === StyleQuizStatus.QUIZ_ORNAMENT"
    @onBack="styleQuizStatus = StyleQuizStatus.QUIZ_STYLE"
    @onDone="styleQuizStatus = StyleQuizStatus.QUIZ_ROOM"
  />
  <StyleQuizRoom
    v-if="styleQuizStatus === StyleQuizStatus.QUIZ_ROOM"
    :projectId="props.projectInfo?.id"
    @onBack="styleQuizStatus = StyleQuizStatus.QUIZ_ORNAMENT"
    @onDone="styleQuizStatus = StyleQuizStatus.DONE"
  />
</template>

<script>
import { ref } from "vue";
import router from "@/router";
import SelectDefinedStyleQuiz from "./styleQuiz/SelectDefinedStyleQuiz.vue";
import StyleQuizResult from "./styleQuiz/StyleQuizResult.vue";
import StyleQuizEmpty from "./styleQuiz/StyleQuizEmpty.vue";
import StyleQuizStyle from "./styleQuiz/stages/StyleQuizStyle.vue";
import StyleQuizOrnament from "./styleQuiz/stages/StyleQuizOrnament.vue";
import StyleQuizRoom from "./styleQuiz/stages/StyleQuizRoom.vue";
import { useAuthStore } from "@/stores/auth.store";
import { Role } from "@/helpsers/role.helper";

export default {
  name: "StyleQuiz",
  props: {
    projectInfo: {
      type: Object,
      default: {},
    },
  },
  components: {
    SelectDefinedStyleQuiz,
    StyleQuizResult,
    StyleQuizEmpty,
    StyleQuizStyle,
    StyleQuizOrnament,
    StyleQuizRoom,
  },
  setup(props) {
    const auth = useAuthStore();

    function goToStyleQuiz() {
      router.push({
        name: "style-quiz-images",
        params: { id: props.projectInfo.id },
      });
    }

    const StyleQuizStatus = {
      EMPTY: "EMPTY",
      DONE: "DONE",
      DEFINED_STYLES_QUIZ: "DEFINED_STYLES_QUIZ",
      // stage 1
      QUIZ_STYLE: "QUIZ_STYLE",
      // stage 2
      QUIZ_ORNAMENT: "QUIZ_ORNAMENT",
      // stage 3
      QUIZ_ROOM: "QUIZ_ROOM",
    };
    const getInitialStyleQuizStatus = () => {
      const projectHasAnyQuiz = Boolean(
        props.projectInfo.styleQuizResults?.length > 0
      );
      if (props.projectInfo.myRoleInProject === Role.Client) {
        if (!projectHasAnyQuiz) {
          return StyleQuizStatus.EMPTY;
        }
        const userHasDoneTheQuiz = props.projectInfo.styleQuizResults.some(
          (result) => result.user.id === auth.user.id
        );
        if (userHasDoneTheQuiz) {
          return StyleQuizStatus.DONE;
        }
        return StyleQuizStatus.EMPTY;
      }
  
      return StyleQuizStatus.DONE;
    };
    const styleQuizStatus = ref(getInitialStyleQuizStatus());

    return {
      goToStyleQuiz,
      styleQuizStatus,
      StyleQuizStatus,
      props,
      getInitialStyleQuizStatus,
    };
  },
};
</script>

<style scoped lang="scss"></style>
